import { render, staticRenderFns } from "./Liket2025.vue?vue&type=template&id=63eae367"
import script from "./Liket2025.vue?vue&type=script&lang=js"
export * from "./Liket2025.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports